import React from 'react';
import { ThemeProvider } from 'styled-components';

import ResourceWorkflow from '../ExternalReferenceWorkflow';

// Theme
import theme from '../../../../theme';

const LogicSetWorkflow = (props) => (
    <ThemeProvider theme={theme}>
        <ResourceWorkflow {...props} />
    </ThemeProvider>
);

export default LogicSetWorkflow;
